import { render, staticRenderFns } from "./categoryDbhLocaltion.vue?vue&type=template&id=3b0d0896&scoped=true&"
import script from "./categoryDbhLocaltion.vue?vue&type=script&lang=js&"
export * from "./categoryDbhLocaltion.vue?vue&type=script&lang=js&"
import style0 from "./categoryDbhLocaltion.vue?vue&type=style&index=0&id=3b0d0896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d0896",
  null
  
)

export default component.exports